import * as React from 'react';
import * as queryString from "query-string";
import { connect, Dispatch } from "react-redux";
import { withRouter, RouteComponentProps } from 'react-router';
import { SwapActionCreators, AppActionCreators, IApplicationState, IAppState } from '@nkr/store/index';
import { ISwapCounts, ISwapCountResponse } from './models';
import { DisplayType, MatchHistoryType } from '@nkr/enums/index';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import Swaps from "./swaps";
import MoveTracker from "./swaps/move-tracker";
import SwapTracker from "./swaps/swap-tracker";
import Ncs from "./ncs";
import Unassigned from "./unassigned";
import TabsNew from "./tabs-new";
import MatchDeadlines from './swaps/deadlines';
import SwapManagementPage from './swaps/swap-management/page';

interface ILocation {
    key: string,
    subKey: string,
    chainStatusId: number,
    clusterStatusId: number
}

interface ISection {
    key: string,
    label: string,
    url: string
}

interface IMatchProps {
    key: string,
    status?: string,
    redesign?: string,
    chainId?: string,
    cluster?: string,
    position?: string
}

interface IOwnProps extends RouteComponentProps<IMatchProps> { }

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    toggleLoading: (showLoading: boolean, message: string) => void;
    getCounts: () => Promise<any>;
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    key: string,
    subKey: string,
    counts: ISwapCounts,
    chainStatusId: number,
    clusterStatusId: number;
    redesign: boolean;
}

const initialState: IState = {
    key: "",
    subKey: "",
    counts: {
        all: 0,
        stalled: 0,
        offers: 0,
        crossMatching: 0,
        logistics: 0,
        kickoff: 0,
        inProcess: 0,
        kflId: 0,
        transplanted: 0,
        shield: 0,
        swapTracker: 0,
        oneWayTracker: 0
    },
    chainStatusId: 0,
    clusterStatusId: 0,
    redesign: false
};

const sections: ISection[] = [
    { key: "SWAPS", label: "SWAPS", url: "" },
    { key: "NCS", label: "NCS", url: "" },
    { key: "UNASSIGNED", label: "UNASSIGNED", url: "" },
    { key: "TARGET", label: "TARGET", url: "" },
    { key: "CENTER", label: "CENTER", url: "" },
    { key: "SOP", label: "SOP", url: "" },
    { key: "GPS", label: "GPS", url: "" },
    { key: "DONOR", label: "EMAIL", url: "" },
    { key: "EMAIL", label: "EMAIL", url: "" },
    { key: "RCCAP", label: "RCCAP", url: "" },
    { key: "XM", label: "XM", url: "" },
    { key: "SER", label: "SER", url: "" },
    { key: "SCHED", label: "SCHED", url: "" },
    { key: "CLC", label: "CLC", url: "" },
    { key: "ARCHIVE", label: "ARCHIVE", url: "" },
    { key: "PHLEBOT", label: "PHLEBOT", url: "" },
];

export class SwapManagement extends React.Component<TProps, IState> {
    readonly state: IState = initialState;

    componentWillMount = () => {
        var parms = queryString.parse(this.props.location.search);

        if (parms.redesign != null)
            this.updateTabs(parms.redesign);
    }

    componentDidMount = () => {
        var path = this.props.match.path;

        var location = this.checkLocation();

        this.setState({
            key: location.key,
            subKey: location.subKey,
            chainStatusId: location.chainStatusId,
            clusterStatusId: location.clusterStatusId
        }, () => {
            this.getData();
        });
    }

    componentWillReceiveProps = () => { }

    updateTabs = (redesign: boolean) => {
        this.setState({
            redesign
        });
    }

    checkLocation = (): ILocation => {
        var path = this.props.location.pathname;
        var parms = queryString.parse(this.props.location.search);
        var key = "";
        var subKey = "";
        var chainStatusId = 0;
        var clusterStatusId = 0;
        var status = -1;

        switch (path) {
            case "/manage-swaps/ncs":
                key = "NCS";
                break;

            case "/manage-swaps/unassigned":
                key = "UNASSIGNED";
                break;

            case "/swap-tracker":
            case "/manage-swaps/swaps/move-tracker":
                key = "SWAPS";
                subKey = "MOVETRACKER";
                break;

            case "/one-way-tracker":
            case "/manage-swaps/swaps/swap-tracker":
                key = "SWAPS";
                subKey = "SWAPTRACKER";
                break;

            case "/manage-swaps/swaps":
                key = "SWAPS";

                switch (parms.status) {
                    case "0": subKey = "ALL"; break;
                    case "1": subKey = "STALL"; break;
                    case "2": subKey = "OFFER"; break;
                    case "3": subKey = "XM"; break;
                    case "4": subKey = "KICKOFF"; break;
                    case "5": subKey = ""; break;
                    case "6": subKey = "XPLANTED"; break;
                    case "7": subKey = "LOG"; break;
                    case "8": subKey = "INPROCESS"; break;
                    case "10": subKey = "KFLID"; break;

                    default:
                        subKey = "ALL";
                        status = 0;
                        break;
                }

                chainStatusId = parms.chain_status ? parseInt(parms.chain_status as string) : 1;
                clusterStatusId = parms.status ? parseInt(parms.status as string) : 0;

                break;

            case "/manage-swaps/match-offer-deadlines":
                key = 'MATCH-OFFER-DEADLINES';
                subKey = '';
                break;

            case "/manage-swaps/donor-clearance-deadlines":
                key = 'DONOR-CLEARANCE-DEADLINES';
                subKey = '';
                break;

            case '/manage-swaps/broken-swaps':
                key = 'SWAPS';
                subKey = 'BROKEN-SWAPS'
                break;

            case '/manage-swaps/ended-chains':
                key = 'SWAPS';
                subKey = 'ENDED-CHAINS'
                break;

            case '/manage-swaps/swap-management':
                key = 'SWAP-MANAGEMENT';
                // subKey = 'SWAP-MANAGEMENT';
                break;

            default:
                if (path.indexOf("/admin/fail-safe/confirmation") >= 0) {
                    key = "SWAPS";
                    subKey = "MOVETRACKER";
                }
        }

        return {
            key,
            subKey,
            chainStatusId,
            clusterStatusId
        };
    }

    getData = () => {
        this.props.getCounts().then((response: ISwapCountResponse) => {
            if (response.data.success) {
                this.setState({
                    counts: response.data.results
                });
            }
        });
    }

    handleSelectTab = (subSelection: ISection) => {
        window.location.href = subSelection.url;
    }

    handleSelectChange = (e: any) => {
        this.setState({
            key: e.target.value
        });
    }

    render = () => {
        const counts = this.state.counts;
        const key = this.state.key ? this.state.key : "NK";
        const subKey = this.state.subKey ? this.state.subKey : "NSK";

        return (
            <div>
                {(this.props.app.display == DisplayType.All || this.props.app.display == DisplayType.TabsOnly) && (
                    <>
                        <MediaQuery minWidth={1066}>
                            <TabsNew
                                tabKey={this.state.key}
                                subTabKey={this.state.subKey}
                                counts={counts}
                                user={this.props.app.user}
                            />
                        </MediaQuery>

                        <MediaQuery maxWidth={1065}>
                            <div style={{ textAlign: "center", marginBottom: 10 }}>
                                <DropdownButton
                                    bsStyle={'primary'}
                                    bsSize="small"
                                    title={'SWAPS'}
                                    key={'topMenu'}
                                    id={`dropdown-basic-topMenu`}
                                >
                                    <MenuItem href={"/manage-swaps/swaps"}>SWAPS</MenuItem>
                                    <MenuItem href={`report/ncs-center-scores`} target="_blank"><span>NCS</span></MenuItem>
                                    <MenuItem href={`target`}><span>TARGET</span></MenuItem>
                                    <MenuItem href={"/admin/centers"}><span>CENTER</span></MenuItem>
                                    <MenuItem href={`admin/gps/pend-gps-assign`}><span>GPS</span></MenuItem>
                                    <MenuItem href={"/admin/reports/dash-board/compare-conversion"}><span>DONOR</span></MenuItem>
                                    <MenuItem href={`admin/email`}><span>EMAIL</span></MenuItem>
                                    <MenuItem href={`admin/rccap`}><span>RCCAP</span></MenuItem>
                                    <MenuItem href={`admin/xm-tracking/shipped-pending-d-center`}><span>XM</span></MenuItem>
                                    <MenuItem href={__OUTSIDEURL__ + "/manage/serology-tracking/kits-shipped"}><span>SER</span></MenuItem>
                                    {/*<MenuItem href={"/admin/serology-tracking"}><span>NEW! SER</span></MenuItem>*/}
                                    <MenuItem href={`swap-call-schedule-report`}><span>SCHED</span></MenuItem>
                                    <MenuItem href={"/report/fcr-report"}><span>FCR</span></MenuItem>
                                    <MenuItem href={"https://outlook.office.com/mail/archive@kidneyregistry.com/"} target='_blank'><span>ARCHIVE</span></MenuItem>
                                    <MenuItem href={`admin/phlebot-tracking`}><span>PHLEBOT</span></MenuItem>
                                </DropdownButton>
                            </div>
                        </MediaQuery>
                    </>
                )}

                {key == "SWAPS" && (
                    <div>
                        {subKey == 'BROKEN-SWAPS' && (
                            <Swaps
                                chainStatusId={2}
                                clusterStatusId={0}
                            />
                        )}

                        {subKey == 'ENDED-CHAINS' && (
                            <Swaps
                                chainStatusId={3}
                                clusterStatusId={0}
                            />
                        )}

                        {['SWAPTRACKER', 'MOVETRACKER', 'SHIELD', 'BROKEN-SWAPS', 'ENDED-CHAINS'].indexOf(subKey) < 0 && (
                            <Swaps
                                chainStatusId={this.state.chainStatusId}
                                clusterStatusId={this.state.clusterStatusId}
                            />
                        )}

                        {subKey == "MOVETRACKER" && (
                            <MoveTracker
                                reloadCounts={this.getData}
                                isOps={false}
                                isCourier={false}
                                chainId={this.props.match.params.chainId}
                                cluster={this.props.match.params.cluster}
                                position={this.props.match.params.position}
                            />
                        )}

                        {subKey == "SWAPTRACKER" && (
                            <SwapTracker
                                isOps={false}
                                reloadCounts={this.getData}
                            />
                        )}

                    </div>
                )}

                {key == "NCS" && (
                    <Ncs />
                )}

                {key == "UNASSIGNED" && (
                    <Unassigned />
                )}

                {key == 'MATCH-OFFER-DEADLINES' && (
                    <MatchDeadlines type={MatchHistoryType.MatchOffer} />
                )}

                {key == 'DONOR-CLEARANCE-DEADLINES' && (
                    <MatchDeadlines type={MatchHistoryType.CrossMatch} />
                )}

                {key == 'SWAP-MANAGEMENT' && (
                    <SwapManagementPage />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        toggleLoading: (showLoading, message) => {
            return dispatch(AppActionCreators.toggleLoading(showLoading, message));
        },
        getCounts: () => {
            return dispatch(SwapActionCreators.getCounts());
        }
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapManagement));
